<div class="overlay" (click)="cerrar()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="header">
      <h3>{{ titulo }}</h3>
      <button class="close-btn" (click)="cerrar()">&times;</button>
    </div>

    <div class="body">
      <p>{{ mensaje }}</p>
    </div>

    <div class="footer">
      <button class="btn-cancel" (click)="cancelar()">{{ botonCancelar }}</button>
      <button class="btn-secondary" *ngIf="botonSecundario" (click)="secundario()">{{ botonSecundario }}</button>
      <button class="btn-confirm" (click)="confirmar()">{{ botonConfirmar }}</button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/confirm-modal/confirm-modal.component.html